<template>
  <div
    v-loading="loading"
    class="app-main-content"
    element-loading-text="Loading..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(170,170,170,0.5)"
  >
    <div class="grid-view">
      <div class="main-content">
        <search-item ref="searchItem" config-module="901" :expand-adv="true" no="1" @advSearchItemCallBack="toAdvancedQuery">
          <div slot="operations" style="display: flex;">
            <span style="color: #666666;">{{ $t('CargoMsg.Cargo_ResponsibilityNew') }}</span>
            <el-select v-model="filter.dataType" style="width: 150px;margin-left: 5px;" no="2" @change="searchChangeHandler">
              <el-option :label="$t('CargoMsg.Cargo_PleaseSelectP')" :value="0" />
              <el-option :label="$t('CargoMsg.Cargo_NotClearedToday')" :value="1" />
              <el-option :label="$t('CargoMsg.Cargo_ToBeClearedToday')" :value="2" />
              <el-option :label="$t('CargoMsg.Cargo_DeclarationTheSameDay')" :value="3" />
            </el-select>
            <el-checkbox v-model="shutOut" style="margin: 0 5px 0 12px;" no="3">{{ $t('CargoMsg.Cargo_ShutOut') }}</el-checkbox>
            <el-checkbox v-model="filter.filterHistory" style="margin: 0 12px 0 7px;" no="4">{{ $t('CargoMsg.Cargo_InculdeHistoricalData') }}</el-checkbox>
            <el-button :disabled="!selectedNode||selectedNode.data.dataType==='0'" type="primary" no="5" @click="trackEventHandler">{{ $t('CargoMsg.Cargo_DeclarationTracking') }}</el-button>
            <el-button :disabled="!selectedNode||selectedNode.data.dataType==='0'" type="primary" no="6" @click="trackFilghtEventHandler">{{ $t('CargoMsg.Cargo_FlightTracking') }}</el-button>
            <el-button type="primary" no="7" @click="batchUpdateStateEventHandler">{{ $t('CargoMsg.Cargo_ModifyDeclarationBatches') }}</el-button>
            <el-button type="primary" no="8" @click="printEventHandler">{{ $t('CargoMsg.Cargo_Print') }}</el-button>
            <el-button type="primary" no="9" @click="hasPrintEventHandler">{{ $t('CargoMsg.Cargo_PrintedTag') }}</el-button>
            <el-button type="primary" no="10" @click="printTagEvent">{{ $t('CargoMsg.Cargo_PrintTag') }}</el-button>
            <el-button type="primary" no="11" @click="checkDataEvent">{{ $t('CargoMsg.Cargo_CheckData') }}</el-button>
          </div>
        </search-item>
        <div class="section grid-wrapper">
          <cargo-ag-grid
            config-module="150003"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :deselect-sub-record="true"
            :row-data="rowData"
            @gridReady="params=>{gridApi=params.api}"
          />
        </div>
        <div class="pagination-wrapper">
          <cargo-pagination
            config-module="150003"
            :total="total"
            :page.sync="pageNum"
            :limit.sync="pageSize"
            @pagination="toAdvancedQuery()"
          />
        </div>
      </div>
    </div>
    <customs-maintain-dialog
      :visible.sync="customsMaintainDialog.visible"
      :job="customsMaintainDialog.job"
      @callback="callback"
    />
    <flight-tracker-dialog
      :visible.sync="flightTrackerDialog.visible"
      :job="flightTrackerDialog.job"
      @callback="callback"
    />
    <upd-declare-customs-state-dialog
      :visible.sync="updDeclareCustomsStateDialog.visible"
      :jobs="updDeclareCustomsStateDialog.jobs"
      @callback="callback"
    />
    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.ctx"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :pre-print-callback="prePrintCallback"
      :printed-callback="printedCallback"
      :v2-check-callback="v2CheckCallback"
    />
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import customsMaintainDialog from './components/aeCustomsInventory/customsMaintainDialog'
import flightTrackerDialog from './components/aeCustomsInventory/flightTrackerDialog'
import updDeclareCustomsStateDialog from './components/aeCustomsInventory/updDeclareCustomsStateDialog'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { DocumentManage, stopBubble } from '@/utils/commonUtil'
import DateUtils from '@/utils/dateUtils'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { Job } from '@/class/model/booking/Job'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { AirExportUtils } from '@/class/cargo/model/utils/AirExportUtils'
import { customsInfoAdvancedQuery } from '@/api/seaExport/customsInfo'
import { getJobByUuid } from '@/api/booking/job'
import { batchUpdate } from '@/api/AirExport/airExportJob'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'

export default {
  name: 'AECustomsInventory',
  components: { searchItem, customsMaintainDialog, flightTrackerDialog, updDeclareCustomsStateDialog, cargoTemplateSelectorDialog },
  data() {
    return {
      loading: false,
      filter: {
        conditions: null,
        branchId: 0,
        dataType: 0,
        filterHistory: true
      },
      shutOut: false,
      pageNum: 1,
      pageSize: 50,
      total: 0,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true, // 如果为true，则不能选择单元格
        suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择
        treeData: true,
        groupDefaultExpanded: 0,
        getDataPath: data => {
          return data.path.split(',')
        },
        autoGroupColumnDef: {
          headerName: this.$t('CargoMsg.Cargo_BusinessNo'),
          colId: 'jobNo',
          field: 'jobNo',
          width: 240,
          headerCheckboxSelection: true,
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: true,
            checkbox: params => {
              return true
            },
            innerRenderer: params => {
              if (params.data.dataType === '0') {
                return params.data.jobNo
              } else {
                const toLookMethod = this.documentManage.getPath('toLook')
                return `<a href="javascript:void(0)" style="border-bottom: 1px solid;" onclick="${toLookMethod}(event)">${params.data.jobNo}</a>`
              }
            }
          }
        },
        onRowDataChanged: event => {
          // 清除单选行
          event.api.clearFocusedCell()
        },
        onCellFocused: event => {
          const nodes = event.api.rowModel.rowsToDisplay
          this.selectedNode = nodes[event.rowIndex] || null
        },
        onSortChanged: event => {
          // 重置单选行
          if (this.selectedNode) {
            event.api.setFocusedCell(this.selectedNode.rowIndex, event.columnApi.getAllDisplayedColumns()[0])
          }
        },
        getRowStyle: (params) => {
          const row = params.data
          const { colorSettings, colorType } = this
          if (colorType) {
            return JobUtils.financeColor(row)
          } else if (row.hasOwnProperty('dataType') && (Number(row.dataType) === 1 || Number(row.dataType) === 2)) {
            if (Object.prototype.hasOwnProperty.call(row, 'blocked') &&
              Object.prototype.hasOwnProperty.call(row, 'specialApproval') &&
              JobUtils.isBlockJob(row)) {
              return { 'background': colorSettings.find(item => item.colorKey === 'isBlocked').colorValue }
            } else {
              const jobState = String(row.jobState) || ''
              for (const stateColor of colorSettings) {
                if (jobState === stateColor.colorKey) {
                  return { 'background': stateColor.colorValue }
                }
              }
            }
          }
          return {}
        },
        context: { componentParent: this }
      },
      columnDefs: [
        {
          headerName: 'MBL',
          field: 'mbl',
          width: 130,
          valueFormatter: params => {
            return AirExportUtils.mawbNoDispalyFormat(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_WarehouseNo'),
          field: 'warehouseNo',
          width: 130
        }, {
          headerName: this.$t('CargoMsg.Cargo_AuthorizedClient'),
          field: 'customerId',
          width: 200,
          valueFormatter: params => {
            if (params.value > 0) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
            }
            return ''
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_DestinationPort'),
          field: 'destinationPortCode',
          width: 110
        }, {
          headerName: this.$t('CargoMsg.Cargo_OperationDate'),
          field: 'customsDate',
          width: 110,
          valueFormatter: params => {
            return DateUtils.formatStandardDate(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_AWBQuantity'),
          field: 'quantityContract',
          width: 110,
          valueFormatter: params => {
            if (params.data.cargoDoc) {
              for (const item of params.data.cargoDoc) {
                if (item && item.docType === CargoDocConsts.MAWB) {
                  return ColumnUtils.formatNumber(item.quantity, 2, true, false)
                }
              }
            }
            return ''
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_AWBWeight'),
          field: 'weightContract',
          width: 110,
          valueFormatter: params => {
            if (params.data.cargoDoc) {
              for (const item of params.data.cargoDoc) {
                if (item && item.docType === CargoDocConsts.MAWB) {
                  return ColumnUtils.formatNumber(item.weight, 2, true, false)
                }
              }
            }
            return ''
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_AWBVolume'),
          field: 'cubageContract',
          width: 110,
          valueFormatter: params => {
            if (params.data.cargoDoc) {
              for (const item of params.data.cargoDoc) {
                if (item && item.docType === CargoDocConsts.MAWB) {
                  return ColumnUtils.formatNumber(item.cubage, 2, true, false)
                }
              }
            }
            return ''
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_ActualQuantity'),
          field: 'quantityActual',
          width: 110,
          valueFormatter: params => {
            return ColumnUtils.formatNumber(params.value, 2, true, false)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_ActualGrossWeight'),
          field: 'weightActual',
          width: 110,
          valueFormatter: params => {
            return ColumnUtils.formatNumber(params.value, 2, true, false)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_ActualVolume'),
          field: 'cubageActual',
          width: 110,
          valueFormatter: params => {
            return ColumnUtils.formatNumber(params.value, 2, true, false)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_GoodsSize'),
          field: 'measurements',
          width: 120,
          valueFormatter: params => {
            if (params.data.warehouseIn) {
              const str = []
              for (const w of params.data.warehouseIn) {
                if (w.warehouseInDetail) {
                  for (const d of w.warehouseInDetail) {
                    if (d && d.dimension && d.dimension.trim()) {
                      str.push(d.dimension)
                    }
                  }
                }
              }
              return str.join(',')
            }
            return ''
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_PrintTag'),
          field: 'printedLabel',
          width: 120,
          valueFormatter: params => {
            return params.value ? '√' : ''
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_CheckData'),
          field: 'checkData',
          width: 120,
          valueFormatter: params => {
            return params.value ? '√' : ''
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_ActualFlight'),
          field: 'actualFlight',
          width: 120
        }, {
          headerName: this.$t('CargoMsg.Cargo_OnwardInformation'),
          field: 'onwardJourney',
          width: 120
        }, {
          headerName: this.$t('SeaExport.ActualDateOfDeparture2'),
          field: 'atd',
          width: 150,
          valueFormatter: params => {
            return ColumnUtils.dateMinutesLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_ChineseCargoName'),
          field: 'cargoChineseName',
          width: 120
        }, {
          headerName: this.$t('CargoMsg.Cargo_EnglishCargoName'),
          field: 'cargoEnglishName',
          width: 120
        }, {
          headerName: this.$t('CargoMsg.Cargo_OperatingCompany'),
          field: 'companyCname',
          width: 180
        }, {
          headerName: this.$t('CargoMsg.Cargo_CustomsDeclarationStatus'),
          field: 'declareCustomsState',
          width: 130,
          valueFormatter: params => {
            const data = params.data
            let declareCustomsState = 0
            if (data.customsInfo && data.customsInfo.length === 1) {
              declareCustomsState = data.customsInfo[0].declareCustomsState
            } else {
              declareCustomsState = data.declareCustomsState
            }
            if (declareCustomsState > 0) {
              const commonState = SystemConstants.getCommonState(declareCustomsState, SystemConstants.DECLARE_CUSTOMS_STATE)
              if (commonState) {
                return commonState.chineseName
              }
            }
            return ''
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_NumberDeclaration'),
          field: 'declareQuantityActual',
          width: 120,
          valueFormatter: params => {
            return ColumnUtils.formatNumber(params.value, 2, true, false)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_DeclarationGrossWeight'),
          field: 'declareWeightActual',
          width: 120,
          valueFormatter: params => {
            return ColumnUtils.formatNumber(params.value, 2, true, false)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_CustomsDeclarationRemarks'),
          field: 'declareRemarks',
          width: 180
        }, {
          headerName: this.$t('CargoMsg.Cargo_AttachmentDescription'),
          field: 'remarks',
          width: 180
        }, {
          headerName: this.$t('CargoMsg.Cargo_OperationRequirement'),
          field: 'operationContent',
          width: 180,
          valueFormatter: params => {
            if (params.value) {
              const arr = params.value.split('\n')
              return arr.join(',')
            }
            return ''
          }
        }, {
          headerName: this.$t('SeaExport.DateOfDeparture2'),
          field: 'etd',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.dateMinutesLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.DateOfArrival2'),
          field: 'eta',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.dateMinutesLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.ActualDateOfArrival2'),
          field: 'ata',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.dateMinutesLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.LoadingPort'),
          field: 'loadingPortCode',
          width: 180,
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'auto_8')
          }
        }, {
          headerName: this.$t('SeaExport.CustomerReferenceNumber'),
          field: 'customerRefNo',
          width: 180
        }, {
          headerName: this.$t('SeaExport.ContactPerson'),
          field: 'customerContact',
          width: 100
        }, {
          headerName: this.$t('SeaExport.Flight'),
          field: 'voyageFlight',
          width: 100
        }, {
          headerName: this.$t('SeaExport.BookingAgent'),
          field: 'bookingAgent',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        }
      ],
      rowData: [],
      selectedNode: null,
      gridApi: null,
      customsMaintainDialog: {
        visible: false,
        job: new Job().fillDefaultValue().getData(),
        callback: result => { }
      },
      flightTrackerDialog: {
        visible: false,
        job: new Job().fillDefaultValue().getData(),
        callback: result => { }
      },
      updDeclareCustomsStateDialog: {
        visible: false,
        jobs: [],
        callback: result => { }
      },
      templateSelectorDialog: {
        visible: false,
        ctx: null,
        category: '',
        data: {}
      },
      prePrintCallback: null,
      printedCallback: null,
      v2CheckCallback: null,
      documentManage: new DocumentManage()
    }
  },
  computed: {
    colorSettings() {
      return this.$store.state.settings.colorSettings
    },
    colorType() {
      return Number(this.$store.state.settings.colorType) === 1
    }
  },
  watch: {
    colorSettings: {
      handler() {
        this.gridOptions.api.redrawRows()
      },
      deep: true
    }
  },
  beforeMount() {
    const self = this
    this.documentManage.set('toLook', function(e) {
      self.toLook(e)
    })
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: {
    // 高级查询
    toAdvancedQuery(data) {
      const filter = this.filter
      if (typeof data !== 'undefined') {
        const option = AdvancedSearchOption.removeOption('job.flight', data)
        if (option) {
          data.push({ ...option, fieldName: 'job.VESSEL' }, { ...option, fieldName: 'job.VOYAGE_FLIGHT' })
        }
        data.push(new AdvancedSearchOption(null, 'job.SHUT_OUT', this.shutOut).formatObj2Json())
        data.push(new AdvancedSearchOption(null, 'job.OP_OFFICE', this.$store.getters.currentOfficeId).formatObj2Json())
        filter.conditions = data
        this.pageNum = 1
      } else if (!filter.conditions) {
        return
      }
      if (this.colorType) {
        // 开启了财务颜色显示
        filter.requires = ['financeColor']
      }
      filter.branchId = this.$store.getters.currentOfficeId
      filter.pageNum = this.pageNum
      filter.pageSize = this.pageSize
      this.loading = true
      customsInfoAdvancedQuery(filter).then(res => {
        this.rowData = res.data.list
        this.pageNum = res.data.pageNum
        this.pageSize = res.data.pageSize
        this.total = Number(res.data.total)
      }).finally(() => {
        this.loading = false
      })
    },
    searchChangeHandler() {
      const etdSearchItem = {
        'itemType': 'date',
        'fieldType': 'FIELD_DATE_RANGE',
        'itemCondition': [
          {
            'code': 'RANGE',
            'chineseName': '范围',
            'englishName': 'Range',
            'selected': false
          }
        ],
        'subType': 'range',
        'defaultConditionVal': 'RANGE',
        'itemName': 'job.ETD',
        'itemLabel': 'SeaExport.DateOfDeparture',
        'itemValue': [],
        'defaultSelected': 1,
        'selected': 0,
        'valueExpression': '',
        'lock': false,
        'defaultValue': []
      }
      const customsDateSearchItem = {
        'itemType': 'date',
        'fieldType': 'FIELD_DATE_RANGE',
        'itemCondition': [
          {
            'code': 'RANGE',
            'chineseName': '范围',
            'englishName': 'Range',
            'selected': false
          }
        ],
        'subType': 'range',
        'defaultConditionVal': 'RANGE',
        'itemName': 'job.CUSTOMS_DATE',
        'itemLabel': 'SeaExport.OperationDate',
        'itemValue': [],
        'defaultSelected': 1,
        'selected': 0,
        'valueExpression': '',
        'lock': false,
        'defaultValue': []
      }
      let date = new Date()
      switch (this.filter.dataType) {
        case 1:
          date.setDate(date.getDate() - 1)
          date = DateUtils.formatStandardDate(date)
          etdSearchItem.itemValue = []
          this.updateSearchItem(etdSearchItem)
          customsDateSearchItem.itemValue = ['', date]
          this.updateSearchItem(customsDateSearchItem, true)
          break
        case 2:
          date = DateUtils.formatStandardDate(date)
          etdSearchItem.itemValue = [date, date]
          this.updateSearchItem(etdSearchItem, true)
          customsDateSearchItem.itemValue = [date, date]
          this.updateSearchItem(customsDateSearchItem, true)
          break
        case 3:
          date = DateUtils.formatStandardDate(date)
          etdSearchItem.itemValue = []
          this.updateSearchItem(etdSearchItem)
          customsDateSearchItem.itemValue = [date, date]
          this.updateSearchItem(customsDateSearchItem, true)
          break
        default:
          etdSearchItem.itemValue = []
          this.updateSearchItem(etdSearchItem)
          customsDateSearchItem.itemValue = []
          this.updateSearchItem(customsDateSearchItem)
          break
      }
    },
    updateSearchItem(item, isCreate = false) {
      const multipleSelection = this.$refs.searchItem.multipleSelection
      const oldItem = multipleSelection.find(p => p.itemName === item.itemName)
      if (oldItem) {
        Object.assign(oldItem, item)
      } else if (isCreate) {
        multipleSelection.push(item)
      }
    },
    // 查看
    toLook(e) {
      stopBubble(e)
      if (!this.$checkPermission(['module_AEBooking'])) {
        this.$message.info(this.$t('AirExport.SorryHavePermissionToInformation'))
        return
      }
      const nodes = this.gridApi.rowModel.rowsToDisplay
      const cell = this.gridApi.getFocusedCell()
      const row = nodes[cell.rowIndex].data
      if (row.jobNo) {
        this.$router.push({
          name: 'AeBooking',
          params: {
            view: 'detail',
            action: 'look',
            jobNo: row.jobNo
          }
        })
      }
    },
    trackEventHandler() {
      const data = this.selectedNode ? this.selectedNode.data : null
      if (!this.checkSelected(data)) {
        this.$message.info(this.$t('AirExport.BusinessInformationSelectionIncorrect'))
        return
      }
      const loading = getLoading4Cxt(this)
      getJobByUuid(data.uuid).then(res => {
        this.customsMaintainDialog.job = res.data
        this.customsMaintainDialog.callback = result => {
          Object.assign(data, result)
          this.gridApi.refreshCells({ force: true })
        }
        this.customsMaintainDialog.visible = true
      }).finally(() => {
        loading.close()
      })
    },
    // 验证选中是否合法
    checkSelected(model) {
      if (!model) {
        return false
      }
      // if(model is CustomsInfo) {
      // 	return false
      // }
      if (model.jobNo === '前一天未报好关') {
        return false
      }
      if (model.jobNo === '当天报关当天航班') {
        return false
      }
      if (model.jobNo === '当天报关') {
        return false
      }
      if (model.masterFlag) {
        return false
      }
      return true
    },
    // 航班跟踪
    trackFilghtEventHandler() {
      if (this.selectedNode) {
        this.flightTrackerDialog.job = this.selectedNode.data
        this.flightTrackerDialog.callback = result => {
          Object.assign(this.selectedNode.data, result)
          this.gridApi.refreshCells({ force: true })
        }
        this.flightTrackerDialog.visible = true
      }
    },
    batchUpdateStateEventHandler() {
      const rows = this.gridApi.getSelectedRows()
      const jobs = []
      if (rows && rows.length > 0) {
        for (const item of rows) {
          if (this.checkSelected(item) && item && item.jobNo !== '其他') {
            jobs.push(item)
          }
        }
      }
      if (jobs.length === 0) {
        this.$message.info(this.$t('CargoMsg.Cargo_PleaseSelectBusiness'))
        return
      }
      this.updDeclareCustomsStateDialog.jobs = jobs
      this.updDeclareCustomsStateDialog.callback = result => {
        for (const item of result) {
          const row = rows.find(p => p.uuid === item.uuid)
          if (row) {
            Object.assign(row, item)
          }
        }
        this.gridApi.refreshCells({ force: true })
      }
      this.updDeclareCustomsStateDialog.visible = true
    },
    printEventHandler() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.info(this.$t('AirExport.PleaseTheCustomsDeclarationList'))
        return
      }
      const uids = Array.from(rows, p => p.uuid)
      this.templateSelectorDialog.category = 'CustomsList'
      this.templateSelectorDialog.data = { CUSTOMS_INFO_UUID: uids.join(','), customsInfo_UUID_List: uids }
      this.templateSelectorDialog.visible = true
    },
    hasPrintEventHandler() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.info(this.$t('CargoMsg.Cargo_PleaseSelectBusiness'))
        return
      }
      for (const row of rows) {
        row.printedLabel = true
      }
      const loading = getLoading4Cxt(this)
      batchUpdate(rows, { airSelectiveType: 'printedLabel' }).then(res => {
        if (res.data) {
          this.$message.success(this.$t('CargoMsg.Cargo_OperationComplete'))
        }
        this.gridApi.refreshCells({ force: true })
      }).finally(() => {
        loading.close()
      })
    },
    printTagEvent() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.info(this.$t('CargoMsg.Cargo_PleaseSelectBusiness'))
        return
      }
      const uids = Array.from(rows, p => p.uuid)
      this.templateSelectorDialog.category = 'AEJOBLABEL'
      this.templateSelectorDialog.data = { JOB_UUID: uids, DOC_UUID: 'null' }
      this.templateSelectorDialog.printedCallback = () => {
        for (const row of rows) {
          row.printedLabel = true
        }
        const loading = getLoading4Cxt(this)
        batchUpdate(rows, { airSelectiveType: 'printedLabel' }).then(res => {
          this.$message.success(this.$t('AirExport.LabelPrintingSucceeded'))
          this.gridApi.refreshCells({ force: true })
        }).finally(() => {
          loading.close()
        })
      }
      this.templateSelectorDialog.visible = true
    },
    checkDataEvent() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.info(this.$t('CargoMsg.Cargo_PleaseSelectBusiness'))
        return
      }
      this.$confirm(this.$t('AirExport.ConfirmAudit'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        for (const row of rows) {
          row.checkData = true
        }
        const loading = getLoading4Cxt(this)
        batchUpdate(rows, { selectiveType: 'checkData' }).then(res => {
          this.$message.success(this.$t('CargoMsg.Cargo_AuditSuccessfullyF'))
          this.gridApi.refreshCells({ force: true })
        }).finally(() => {
          loading.close()
        })
      }).catch(() => { })
    },
    callback(res) {
      if (res) {
        this.$message.success(this.$t('CargoMsg.Cargo_OperationComplete'))
      }
    }
  }
}
</script>

<style scoped lang="scss">
#app .app-main-content .grid-view .main-content ::v-deep {
  .cargo-advance-search-toggle-trigger {
    display: none;
  }
  .grid-wrapper {
    .ag-theme-balham {
      .ag-group-value {
        a {
          color: blue;
        }
      }
      .ag-row-hover,
      .ag-row-focus {
        .ag-group-value {
          a {
            color: unset;
          }
        }
      }
    }
  }
}
</style>
